import { FilterOperator, IFilterItem } from "../../types/filters";

export const filterOutUndefinedFilters = (filters: IFilterItem[], payload: IFilterItem): IFilterItem[] => {
  let newFilters: IFilterItem[] = [...filters];

  if (payload.operator === FilterOperator.IsEqualTo && payload.value === undefined) {
    newFilters = newFilters.filter((item) => item.id !== payload.id);
  }

  return newFilters;
};
